import type { Appointments } from "@/lib/appointments"
import { emptyAppointmentOfferingsPayload } from "@/lib/appointments/emptyPayload"

export const buildAppointmentsPerformResults = ({
  appointmentOfferings = emptyAppointmentOfferingsPayload,
}: {
  appointmentOfferings?: Appointments.OfferingsCache.Payload
} = {}): Appointments.PerformResults => {
  return {
    appointmentOfferings,
  }
}
